<template>
  <v-layout row>
    <v-flex xs12 sm12>
      <v-card height="100%">
        <v-list>
          <template v-for="(item, index) in items">
            <v-subheader primary-title class="primary title white--text" v-if="item.header" :key="item.header" v-html="item.header">
            </v-subheader>
            <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>
            <template v-else-if="!item.isMultiple">
            <router-link tag="v-list-tile"
              :to="{ 
                name: item.link
              }"
              :key="item['.key']" avatar >
                <v-list-tile-avatar>
                  <i class="material-icons primary--text">
                    {{item.icon}}
                  </i>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title" class="primary--text font-weight-bold"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.subtitle" class="primary--text font-weight-light"></v-list-tile-sub-title>
                </v-list-tile-content>
            </router-link>
          </template>
          <template v-else-if="item.isMultiple">
              <v-list-group
                :key="item.title"
                :value="false"
            >
            
              <template v-slot:activator>
                  <v-list-tile-avatar :style="item.style">
                  <i class="material-icons primary--text" style="padding-left: 25px;">
                    {{item.icon}}
                  </i>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title" class="subheading primary--text font-weight-bold"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.subtitle" class="primary--text font-weight-light"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>

                <template
                  v-for="(item1,index1) in item.children"
                >
                 <v-divider v-if="item1.divider" :inset="item.inset" :key="index1"></v-divider>

                  <router-link v-else tag="v-list-tile"
                    style="padding-left: 35px;"
                  :to="{ 
                    name: item1.link
                  }"
                  :key="item1['.key']" avatar >
                <v-list-tile-avatar>
                  <i class="material-icons primary--text">
                    {{item1.icon}}
                  </i>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item1.title" class="primary--text font-weight-bold"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item1.subtitle" class="primary--text font-weight-light"></v-list-tile-sub-title>
                </v-list-tile-content>
                </router-link>
                </template>
              </v-list-group>
            </template>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      items: [
        {
          header: 'Settings'
        },
        {
          title: 'Brand Management',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'Manage Firm Data, Add Permissions to Staff users',
          icon: 'shopping_basket',
          isMultiple : true,
          children: [
            {
              title: 'Admin Accounts',
              subtitle: 'Create & Manage User accounts',
              link: 'AdminAccounts',
              icon: 'admin_panel_settings'
            },
            { divider: true, inset: true },
            {
              title: 'Data Management',
              subtitle: 'Manage your data',
              link: 'DataManagement',
              icon: 'article'
            },
            { divider: true, inset: true },
            {
              title: 'Product Import',
              subtitle: 'Import your Product',
              link: 'ImportFromExcel',
              icon: 'shopping_basket'
            },
            { divider: true, inset: true },
            {
              title: 'Customer Import',
              subtitle: 'Import your Customer',
              link: 'ImportCustomerFromExcel',
              icon: 'account_circle'
            },
            { divider: true, inset: true },
            {
              title: 'Supplier Import',
              subtitle: 'Import your Supplier',
              link: 'ImportSupplierFromExcel',
              icon: 'supervised_user_circle'
            },
            { divider: true, inset: true },
          ]
        },
        
        {
          title: 'Firm Management',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'Manage Firms, Branches, Invoices and Print Options',
          icon: 'domain',
          isMultiple : true,
          children: [
            {
              title: 'Firms',
              subtitle: 'Create & Manage Firm',
              link: 'Firms',
              icon: 'add_task',
            },
            { divider: true, inset: true },
            {
              title: 'Print Settings',
              subtitle: 'Create and Manage Print Format',
              link: 'Print',
              icon: 'print'
            },
            { divider: true, inset: true },
            {
              title: 'Invoice Settings',
              subtitle: 'Create Customized Invoice Id',
              link: 'FirmSettings',
              icon: 'note_add'
            },
            { divider: true, inset: true },
            {
              title: 'Branch Settings',
              subtitle: 'Create & Manage Branch',
              link: 'Branch',
              icon: 'storefront'
            },
          ]
        },
        { divider: true, inset: true },
        {
          title: 'Bank Account Management',
          subtitle: 'Create & Manage Bank Accounts',
          link: 'Account',
          icon: 'account_balance'
        },
        { divider: true, inset: true },
        // {
        //   title: 'Assets Accounts',
        //   subtitle: 'Manage assets',
        //   link: 'Asset',
        //   icon: 'account_balance_wallet'
        // },
        // { divider: true, inset: true },
        // {
        //   title: 'Loan Accounts',
        //   subtitle: 'Manage Loans',
        //   link: 'Loan',
        //   icon: 'account_balance_wallet'
        // },
        // { divider: true, inset: true },
        // {
        //   title: 'Loan & Advances Accounts',
        //   subtitle: 'Manage Loans & Advances',
        //   link: 'Loanadvances',
        //   icon: 'account_balance_wallet'
        // },
        // { divider: true, inset: true },
        {
          title: 'Team Management',
          subtitle: 'Create & Manage Team',
          link: 'Staff',
          icon: 'addchart'
        },
        // { divider: true, inset: true },
        // {
        //   title: 'Print',
        //   subtitle: 'Create and Manage Print Format',
        //   link: 'Print',
        //   icon: 'print'
        // },
        { divider: true, inset: true },
        {
          title: 'Product Management',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'Manage Products via Category, Group, Set and Type',
          icon: 'open_with',
          isMultiple : true,
          children: [
            {
              title: 'Product Category',
              subtitle: 'Create Categories to Differentiate Products',
              link: 'ProductCategory',
              icon: 'category'
            },
            { divider: true, inset: true },
            {
              title: 'Product Group',
              subtitle: 'Create Groups to Differentiate Products',
              link: 'ProductGroup',
              icon: 'group_work'
            },
            { divider: true, inset: true },
            {
              title: 'Product Set',
              subtitle: 'Create Multiple Products',
              link: 'ProductSet',
              icon: 'merge_type'
            },
            { divider: true, inset: true },
            {
              title: 'Product Type',
              subtitle: 'Create Types to Differentiate Products',
              link: 'ProductType',
              icon: 'pie_chart'
            },
            { divider: true, inset: true },
            {
              title: 'Rate Category',
              subtitle: 'Create Categories to add Multiple Rates',
              link: 'ProductRateCategory',
              icon: 'category'
            },
            { divider: true, inset: true },
            {
              title: 'Product Unique ID',
              subtitle: 'Add Unique Ids ( HUID | RFID )',
              link: 'ProductUniqueId',
              icon: 'group_work'
            },
            { divider: true, inset: true },
            {
              title: 'Product Offers',
              subtitle: 'Add Update Product Offers',
              link: 'ProductOffers',
              icon: 'group_work'
            },
            { divider: true, inset: true },
             {
              title: 'Product Manufacturing',
              subtitle: 'Convert Products for manufacturing',
              link: 'ProductManufacturing',
              icon: 'group_work'
            },
            { divider: true, inset: true },
            {
              title: 'Product Damage',
              subtitle: 'Remove Damaged product',
              link: 'ProductDamage',
              icon: 'group_work'
            },
            { divider: true, inset: true },
            {
             title: 'Product Replacement',
             subtitle: 'Product Replacement',
             link: 'ProductReplacement',
             icon: 'group_work'
            }, 
            { divider: true, inset: true },
            {
             title: 'Product Repair',
             subtitle: 'Product Repair',
             link: 'ProductRepair',
             icon: 'group_work'
            }, 
            { divider: true, inset: true },
            {
            title: 'Product Drawer',
            subtitle: 'Product Drawer',
            link: 'productDrawer',
            icon: 'group_work'
           },
          ]
        },
        // { divider: true, inset: true },
        // {
        //   title: 'Employee Management',
        //   style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        //   subtitle: 'Manage Employee Information, Attendance, Reports',
        //   icon: 'group',
        //   isMultiple : true,
        //   children: [
        //     { divider: true, inset: true },
        //     {
        //       title: 'Staff Information',
        //       subtitle: 'Create & Manage Staff',
        //       link: 'HumanResource',
        //       icon: 'support'
        //     },
        //     { divider: true, inset: true },
        //     {
        //       title: 'Staff Attendance',
        //       subtitle: 'Manage Staff Attendance',
        //       link: 'StaffAttendance',
        //       icon: 'support'
        //     },
        //     { divider: true, inset: true },
        //     {
        //       title: 'Payroll Report',
        //       subtitle: 'Create and View Payroll',
        //       link: 'Payroll',
        //       icon: 'support'
        //     },
        //     { divider: true, inset: true },
        //     {
        //       title: 'Letter Head',
        //       subtitle: 'Create Letter Head',
        //       link: 'LetterHead',
        //       icon: 'email'
        //     },
        //     { divider: true, inset: true },
        //     {
        //       title: 'ToDo List',
        //       subtitle: 'Create To Do List',
        //       link: 'Todo',
        //       icon: 'work'
        //     },    
        //   ]
        // },
        { divider: true, inset: true },
        {
          title: 'Operational Management',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'Manage Operationals via Lead, Order and Invoice',
          icon: 'list_alt',
          isMultiple : true,
          children: [
            {
              title: 'Order Management',
              subtitle: 'Create Settings to manage orders',
              link: 'OrderSettings',
              icon: 'content_paste'
            },
            { divider: true, inset: true },
            {
              title: 'Lead Management',
              subtitle: 'Create Settings to manage leads',
              link: 'LeadSettings',
              icon: 'repeat_on'
            },
            { divider: true, inset: true },
            {
              title: 'Todo Work Management',
              subtitle: 'Create & Manage Todo List',
              link: 'Todo',
              icon: 'assignment'
            },
          ]
        },
        { divider: true, inset: true },
        {
          title: 'Store Management',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'Create, Manage and Transfer Product within Godown',
          icon: 'store',
          isMultiple : true,
          children: [
            {
              title: 'Godown',
              subtitle: 'Create & Manage Godowns',
              link: 'Godawn',
              icon: 'store'
            },
            { divider: true, inset: true },
            {
              title: 'GodownTransfer',
              subtitle: 'Transfer Products',
              link: 'GodawnBulkTransfer',
              icon: 'group_work'
            },
          ]
        },
      // Start of Transactions:
      // {
      //   title: 'Transactions',
      //   style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
      //   subtitle: 'Create and Manage Cash Transfer, Bank Account Transfer',
      //   icon: 'shopping_basket',
      //   isMultiple : true,
      //   children: [
      //     {
      //       title: 'Transfer',
      //       subtitle: 'Transfer amount',
      //       link: 'Transfer',
      //       icon: 'admin_panel_settings'
      //      },
      //     { divider: true, inset: true },
      //   ]
      // },
      // Start of Shop Setting:  
      { divider: true, inset: true },      
      {
        title: 'Image Store Management',
        subtitle: 'Add Images for Product',
        link: 'ShopSettings',
        icon: 'collections'
      },
      { divider: true, inset: true },      
        {
          title: 'Infrastructure Management',
          subtitle: 'Add Edit floors and tables',
          link: 'Infrastructure',
          icon: 'workspaces'
        }             
      ]
    }
  }
}
</script>
<style scoped>
  .avatar {
    background: #01579b;
    color: white
  }
</style>


// WEBPACK FOOTER //
// src/components/Settings/Sidebar.vue